module.exports = __webpack_public_path__ + "img/estrella-verde.35ea4847.png";